<progress-spinner *ngIf="isLoading"></progress-spinner>
<div class="container" *ngIf="initialised && !isLoading">
  <div class="modal-header">
    <div class="title">
      <span class="header">Last results for {{ csvFileName }}</span>
    </div>
    <div class="btn-group" (click)="closeDialog()">
      <i class="mdi mdi-close close-icon"></i>
    </div>
  </div>
  <div class="content">
    <div class="status-container">
      <span class="counts"
        >Succeeded: {{ successCount }}, Skipped: {{ skippedCount }}, Failed:
        {{ failureCount }}</span
      >
    </div>

    <!-- Scrollable table content -->
    <div
      class="images-table"
      *ngIf="mappingTable && mappingTable.columns && mappingTable.columns.length > 0"
    >
      <viavi-table [tableConfigurations]="mappingTable" [showToolbar]="false"></viavi-table>
    </div>

    <div class="popup-actions">
      <div class="btn-group ">
        <button
          mat-button
          class="save-btn cancel"
          (click)="copyToClipboard()">
          <i class="mdi mdi-content-copy"></i> COPY TO CLIPBOARD</button>
        <button
          mat-button
          class="save-btn cancel"
          (click)="downloadViewLastResultFile()">
          <i class="mdi mdi-download"></i> DOWNLOAD</button>
        <button mat-button class="save-btn cancel" (click)="closeDialog()">CLOSE</button>
      </div>
    </div>
  </div>
</div>
